import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import React, { Component } from "react";
import { connect } from "react-redux";
import RolComponent from "./RolComponent";
import DenyComponent from "./DenyComponent";
import FacultyComponent from "./FacultyComponent";
import UserListComponent from "./UserListComponent";

class AccessModule extends Component {

    state = {
        tabIndex: 0
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {}

	componentDidUpdate(prevState) {}

    ///---------------------------------------VIEW-------------------------------------

    render() {
        return ( 
            <div className="main-content">
                <div className="malls-category-headers">
                    Accesos
                </div>
                <div className="user-category-wrapper">
                    <Tabs
                        selectedIndex={this.state.tabIndex}
                        onSelect={tabIndex => this.setState({ tabIndex })}
                        default={true}
                    >
                        <TabList >
                            <Tab>Usuarios</Tab>
                            <Tab>Roles</Tab>
                            <Tab>Permisos</Tab>
                            <Tab>Denegaciones</Tab>
                        </TabList>
                        <center>
                            <TabPanel>
                                <UserListComponent />
                            </TabPanel>
                            <TabPanel>
                                <RolComponent />
                            </TabPanel>
                            <TabPanel>
                                <FacultyComponent />
                            </TabPanel>
                            <TabPanel>
                                <DenyComponent />
                            </TabPanel>
                        </center>
                    </Tabs>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps, {
    }
)(AccessModule);